import React, {useRef, useState} from 'react';
import {TreeItem, TreeView} from "@material-ui/lab";
import {Button, ButtonGroup, Divider, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown.js";
import ArrowRightIcon from "@material-ui/icons/ArrowRight.js";
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles((theme) => ({
    labelRoot: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: theme.spacing(0.5, 0),
    },
    labelIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.primary.main
    },
    deletedLabelIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.action.disabled
    },
    labelText: {
        fontWeight: 'inherit',
        flexGrow: 1,
    },
    divider: {
        margin: theme.spacing(1)
    },
    treeContent: {
        alignItems: 'flex-start',
    },
    iconContainer: {
        marginTop: 6,
    },
    treeContainer: {
        height: 'calc(100vh - 230px)',
        overflowY: "auto"
    }
}))

const TreeToolbar = (props) => {
    const {isToolbarDisabled, hidden, buttonGroupRef, isAbleToPaste, onAdd, onEdit, onCut, onPaste, onDelete, onCopy} = props

    return (
        <div hidden={hidden}>
            <ButtonGroup size={'small'} variant={'text'} hidden ref={buttonGroupRef}>
                <Button onClick={onAdd}><AddOutlinedIcon/></Button>
                <Button disabled={isToolbarDisabled} onClick={onEdit}><EditOutlinedIcon/></Button>
                <Button disabled={isToolbarDisabled} onClick={onDelete}><DeleteOutlinedIcon/></Button>
                <Button disabled={isToolbarDisabled} onClick={onCopy}><FileCopyIcon/></Button>
                <Button disabled={isToolbarDisabled} onClick={onCut}><ArrowUpwardIcon/></Button>
                <Button disabled={!isAbleToPaste} onClick={onPaste}><ArrowDownwardIcon/></Button>
            </ButtonGroup>
        </div>
    );
}

const DocumentsTreeView = (props) => {
    const {nodes, typeIcons, isAbleToPaste, iconTooltips, toolbarCallbacks, hideToolbar = false} = props

    const classes = useStyles()

    const [selectedNode, setSelectedNode] = useState('')

   

    const buttonGroupRef = useRef()

    const handleSelection = async (_, value) => {
        await setSelectedNode(value)
    }

    const handleDoubleClick = () => {
        if (toolbarCallbacks.onDoubleClick) toolbarCallbacks.onDoubleClick(selectedNode)()
    }

    const handleUnselect = async (event) => {
        if (!event.currentTarget.contains(event.relatedTarget) && event.relatedTarget?.parentElement !== buttonGroupRef.current) {
            await setSelectedNode('')
        }
        if (event.relatedTarget?.parentElement === buttonGroupRef.current) {
            event.target.focus()
        }
    }

    const renderTree = (node) => {
        const Icon = typeIcons[node.type]

        return (
            <TreeItem
                key={node.id}
                nodeId={`${node.type}.${node.id}`}
                onLabelClick={event => event.preventDefault()}
                classes={{content: classes.treeContent, iconContainer: classes.iconContainer}}
                label={
                    <div className={classes.labelRoot}>
                        <Tooltip title={`${iconTooltips[node.type]}${node.deleted ? ': удалено' : ''}`}>
                            <Icon className={node.deleted ? classes.deletedLabelIcon : classes.labelIcon}/>
                        </Tooltip>
                        <Typography variant="body2" className={classes.labelText}>
                            {node.name}
                        </Typography>
                    </div>
                }>
                {Array.isArray(node.children) ? node.children.map((childNode) => renderTree(childNode)) : null}
            </TreeItem>
        );
    }

    return (
        <>
            <TreeToolbar
                isToolbarDisabled={!Boolean(selectedNode)}
                hidden={hideToolbar}
                buttonGroupRef={buttonGroupRef}
                isAbleToPaste={isAbleToPaste}
                onAdd={toolbarCallbacks.onAdd ? toolbarCallbacks.onAdd(selectedNode) : null}
                onEdit={toolbarCallbacks.onEdit ? toolbarCallbacks.onEdit(selectedNode) : null}
                onDelete={toolbarCallbacks.onDelete ? toolbarCallbacks.onDelete(selectedNode) : null}
                onCut={toolbarCallbacks.onCut ? toolbarCallbacks.onCut(selectedNode) : null}
                onPaste={toolbarCallbacks.onPaste ? toolbarCallbacks.onPaste(selectedNode) : null}
                onCopy={toolbarCallbacks.onCopy ? toolbarCallbacks.onCopy(selectedNode) : null}
            />
            <Divider className={classes.divider} hidden={hideToolbar}/>
            <TreeView
                defaultCollapseIcon={<ArrowDropDownIcon/>}
                defaultExpandIcon={<ArrowRightIcon/>}
                onNodeSelect={handleSelection}
                onBlur={handleUnselect}
                onDoubleClick={handleDoubleClick}
                selected={selectedNode}
                className={classes.treeContainer}
            >
                {nodes.map(node => renderTree(node))}
            </TreeView>
        </>
    );
};

export default DocumentsTreeView;